/** 'Josh Ponelat' → 'JP'; used for the amber note avatars. */
export function initials(name: string): string {
  return (
    name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase() || '?'
  )
}
